import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";

export const OptionCard = ({ option, selected, onSelect, suffix = "", testId }) => (
  <motion.button
    type="button"
    onClick={onSelect}
    whileHover={{ y: -4 }}
    whileTap={{ scale: 0.98 }}
    aria-pressed={selected}
    data-testid={testId}
    className={`relative flex h-full flex-col rounded-2xl border p-6 text-left transition-[background-color,border-color,box-shadow,color] duration-300 ${
      selected
        ? "border-jade bg-jade text-paper shadow-[0_20px_50px_-20px_rgba(35,83,71,0.6)]"
        : "border-jade/10 bg-white/80 text-ink shadow-ambient backdrop-blur-sm hover:border-jade/30"
    }`}
  >
    <span className="flex items-center justify-between">
      <span className="flex items-center gap-2 font-display text-2xl font-medium">
        {option.label}
        {option.recommended && (
          <Star className={`h-4 w-4 ${selected ? "fill-paper text-paper" : "fill-amber-400 text-amber-400"}`} />
        )}
      </span>
      <span
        className={`flex h-6 w-6 items-center justify-center rounded-full border transition-colors duration-300 ${
          selected ? "border-paper bg-paper text-jade" : "border-jade/20"
        }`}
      >
        {selected && <Check className="h-3.5 w-3.5" strokeWidth={3} />}
      </span>
    </span>
    {option.recommended && (
      <span className={`mt-2 w-fit rounded-full px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] ${selected ? "bg-paper/15 text-paper" : "bg-jade/10 text-jade"}`}>
        Recommended
      </span>
    )}
    <span className="mt-5 font-display text-3xl">
      {option.price === null ? "Quote" : `£${option.price.toLocaleString("en-GB")}`}
      {option.price !== null && suffix && <span className="text-base opacity-70">{suffix}</span>}
    </span>
    <span className={`mt-3 text-sm leading-relaxed ${selected ? "text-paper/80" : "text-ink2/70"}`}>{option.detail}</span>
  </motion.button>
);
